import apisauce from 'apisauce'

export default {
  create: () => {
    const csrf = document
      .querySelector("meta[name='csrf-token']")
      .getAttribute('content')
    const api = apisauce.create({
      baseURL: `${process.env.BASE_URL}/web`,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf,
      },
      timeout: 10000,
    })

    return {
      updateSettings: (id, params) => api.put(`settings/${id}`, params),
      updateContactButton: (id, params) =>
        api.put(`contact_buttons/${id}`, params),
      getProductDetails: (params) => api.get(`products`, params),
      getAppointments: (params) => api.get(`appointments`, params),
      upsertAppointments: (params) => api.put(`appointments/upsert`, params),
      getCalendlyEvents: (_) => api.get(`settings/calendly_events`),
      getProducts: (params) => api.get(`products/product_list`, params),
      getShopifyProducts: (params) =>
        api.get(`products/shopify_products`, params),
      updateProduct: (params) => api.put(`products/upsert`, params),
      upgradePlan: (params) => api.put(`plans/upgrade`, params),
      cancelPlan: (_) => api.put(`plans/cancel`),
      sendTestEmail: (params) => api.put(`appointments/send_email`, params),
      singleUpsertAppointments: (params) =>
        api.put(`appointments/single_upsert`, params),
      addCalendlyToken: (params) => api.post(`settings/add_token`, params),
      removeCalendlyToken: (params) =>
        api.delete(`settings/remove_token`, params),
      updateAppointmentConfig: (params) =>
        api.put(`appointments/${params.id}/update_configuration`, params),
      getBookings: (params) => api.get(`appointments/bookings`, params),
      getBookingDetails: (params) => api.get(`appointments/bookings`, params),
      cancelBooking: (params) =>
        api.delete(`appointments/cancel_booking`, params),
      rescheduleBooking: (params) =>
        api.put(`appointments/reschedule_booking`, params),
      updateShop: (params) => api.put(`settings/shop_setting`, params),
      deleteCustomField: (apptId, params) =>
        api.delete(`appointments/${apptId}/delete_custom_field`, params),
      getConflicts: () => api.get(`/appointments/conflicts`),
      getTextEmailSettings: () => api.get(`/email_settings`),
      getEmailSettings: () => api.get(`settings/get_sender_signature`),
      sendVerificationEmail: () =>
        api.put(`settings/resend_signature_verification`),
      updateEmailSettings: (params) =>
        api.put(`settings/upsert_sender_signature`, params),
      upsertTextEmailSettings: (params) =>
        api.put(`email_settings/upsert`, params),
      getShopifyCustomers: (params) => api.get(`customers`, params),
      generateBookingLink: (params) =>
        api.post(`appointments/create_booking`, params),
      connectGoogleCalendar: (params) =>
        api.post(`settings/google_calendar_auth`, params),
      updateCustomer: (id, params) => api.put(`customers/${id}`, params),
      removeGoogleCalendar: (params) =>
        api.delete(`settings/disconnect_google`),
      getTeams: () => api.get(`teams`),
      createTeam: (params) => api.post(`teams`, params),
      deleteTeam: (id) => api.delete(`teams/${id}`),
      sendMemberVerificationEmail: (id) =>
        api.put(`teams/${id}/send_confirmation`),
      removeZoom: (_) => api.delete(`settings/disconnect_zoom`),
      updateTeamMemberSetting: (params) =>
        api.put(`settings/member_setting`, params),
      createCustomer: (params) => api.post(`customers`, params),
      getCalendarBookings: (params) =>
        api.get(`appointments/calendar_bookings`, params),
      searchAppointments: (params) => api.get(`/appointments/search`, params),
      createNote: (id, params) => api.put(`bookings/${id}/upsert_note`, params),
      deleteNote: (id, params) =>
        api.delete(`bookings/${id}/delete_note`, params),
      getAllCalendars: () => api.get('settings/all_calendars'),
      getSubscriptions: (params) =>
        api.get(`/appointment_subscriptions`, params),
      getCancelledBookings: (params) =>
        api.get(`appointments/cancelled_bookings`, params),
      getCancelledBookingDetails: (params) =>
        api.get(`appointments/cancelled_bookings`, params),
      multipleUpsertAppointments: (params) =>
        api.put(`appointments/multiple_upsert`, params),
      getBookingSubscription: (id) =>
        api.get(`appointment_subscriptions/${id}`),
      getLegacySubscriptions: () => api.get(`/appointments/subscriptions`),
      deleteSubscription: (id) => api.delete(`appointment_subscriptions/${id}`),
      updateCustomerPaymentMethod: (params) =>
        api.put(
          `appointment_subscriptions/update_customer_payment_method`,
          params
        ),
      createManualSubscription: (params) =>
        api.post(`/appointment_subscriptions`, params),
      bookingsByCustomer: (params) =>
        api.get(`appointment_subscriptions/unconnected_customers`, params),
      connectBookingToSubscription: (params) =>
        api.put(`appointment_subscriptions/connect_booking`, params),
      updateSubscriptionDetails: (params) =>
        api.put(`appointment_subscriptions/${params.id}`, params),
      retrySubscriptionBilling: (params) =>
        api.put(`appointment_subscriptions/retry_billing`, params),
      getCustomers: (params) => api.get('customers/list', params),
      getCustomerDetails: (params) =>
        api.get(`customers/customer_info`, params),
      getCustomerMessages: (params) => api.get(`customers/messages`, params),
      sendMessage: (params) => api.put(`customers/send_sms`, params),
      markAsRead: (params) => api.put(`customers/mark_sms_as_read`, params),
      updateAllCustomer: (params) =>
        api.put(`customers/update_cust_by_email_and_name`, params),
      connectAppleCalendar: (params) =>
        api.post(`settings/apple_calendar_auth`, params),
      disconnectAppleCalendarRequest: (params) =>
        api.delete(`settings/disconnect_apple_calendar`, params),
      getWaitlists: (params) => api.get(`waitlist`, params),
      upsertWaitlist: (params) => api.put(`waitlist/${params.id}`, params),
      addToWaitlist: (params) => api.post(`waitlist`, params),
    }
  },
}
